import {
  SIGNUP_ADMIN_USER,
  SIGNUP_ADMIN_USER_SUCCESS,
  SIGNUP_ADMIN_USER_ERROR,
} from "./actionTypes"

const initialState = {
  error: null,
  loading: false,
  admin_user: null,
}

const AdminUserSignup = (state = initialState, action) => {
  switch (action.type) {
    case SIGNUP_ADMIN_USER:
      state = {
        ...state,
        loading: true,
        error: false,
      }
      break
    case SIGNUP_ADMIN_USER_SUCCESS:
      state = {
        ...state,
        loading: false,
        admin_user: action.payload,
        error: false,
      }
      break
    case SIGNUP_ADMIN_USER_ERROR:
      state = {
        ...state,
        admin_user: null,
        loading: false,
        error: action.payload,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default AdminUserSignup;
